export default __webpack_public_path__ + "static/media/thumbnail.6964737d.png";